var map = {
	"./ar/label.json": 33549,
	"./cs/label.json": 91195,
	"./cy/label.json": 95685,
	"./da/label.json": 80213,
	"./de/label.json": 85498,
	"./en/label.json": 34028,
	"./es/label.json": 68459,
	"./fi/label.json": 91855,
	"./fr/label.json": 10541,
	"./he/label.json": 24801,
	"./hi/label.json": 92215,
	"./hr/label.json": 26112,
	"./hu/label.json": 58647,
	"./it/label.json": 21010,
	"./ja/label.json": 27078,
	"./kk/label.json": 2987,
	"./kn/label.json": 69318,
	"./ko/label.json": 10845,
	"./ml/label.json": 76683,
	"./mr/label.json": 40346,
	"./nl/label.json": 69127,
	"./pl/label.json": 46256,
	"./pt/label.json": 43538,
	"./ro/label.json": 32678,
	"./ru/label.json": 25513,
	"./sh/label.json": 37175,
	"./sk/label.json": 65764,
	"./sr/label.json": 67028,
	"./sv/label.json": 3534,
	"./ta/label.json": 54607,
	"./te/label.json": 25883,
	"./vi/label.json": 22534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64352;